import static_datas from "./static_datas";
import dynamic_datas from "./dynamic_datas";

export default {
    ...static_datas,
    ...dynamic_datas,
};
